module.exports = function getResource(label, vars = []) {
    const resources = {
        close: 'Fermer',
        shopNow: 'Magasinez maintenant, payez plus tard',
        interestFree: 'Quatre versements sans intérêt de',
        addItems: 'Ajoutez des articles que vous aimez à votre panier.',
        choose: 'Choisisr',
        atCheckout: 'à la caisse',
        purchaseSplit: 'Votre achat sera divisé en quatre versements sans intérêt égaux. Le premier paiement est dû lorsque votre commande est expédiée.',
        remainingPayment: 'Les trois paiements restants seront automatiquement portés à votre carte de débit ou de crédit toutes les deux semaines.',
        learnMore: 'En savoir plus',
        completeTerms: 'Voir toutes les modalités.',
        californiaTerms: 'Pour les résidents de la Californie : prêts consentis ou mis en place conformément à une licence de la California Finance Lenders Law.',
        caTermFirst: 'Les conditions de l’option « Payez plus tard en 4 versements » sont offertes ',
        caTermLinkFirst: 'ici',
        caTermSecond: 'Pour les résidents du Québec, les conditions de l’option « Payez plus tard en 4 versements » ',
        caTermLinkSecond: 'conditions',
        caTermsThird: 'sont applicables.',
        gotIt: 'Compris',
        pbBuyNowPayLater: 'Achetez maintenant, payez plus tard',
        pbInterestFreePayments: 'en quatre paiements sans intérêt aux deux semaines',
        pbPayAsLittleAs: `Payez aussi peu que ${vars[0]} en quatre versements en fonction dʼun prix dʼachat de ${vars[1]} à un taux d’intérêt annuel de 0 %.`,
        pbInstantDecision: 'Décision instantanée',
        pbEnterFewDetails: 'Entrez quelques renseignements pour obtenir une décision en temps réel.',
        pbEasyPayments: 'Paiements faciles',
        pbAutomaticCharge: 'Automatiquement facturés selon le mode de paiement que vous préférez.',
        pbSimplySelect: 'Sélectionnez simplement PayBright à la caisse.',
        pbTermsFirst: '*Le montant estimé des versements toutes les deux semaines exclut les taxes, les frais d’expédition et les autres frais. Certaines conditions s’appliquent et toutes les transactions sont assujetties à l’approbation de PayBright. Visitez le site',
        pbFAQ: 'FAQ PayBright',
        pbTermsSecond: 'pour obtenir de plus amples renseignements.'
    };

    return resources[label];
};
